import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-4 row gx-4 gx-lg-4 row-cols-1 row-cols-md-2 row-cols-xl-4 justify-content-center cursor-pointer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card h-100 shadow" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "bd-placeholder-img card-img-top h-100",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Placeholder",
    preserveAspectRatio: "xMidYMid slice",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "Placeholder"),
    /*#__PURE__*/_createElementVNode("rect", {
      width: "100%",
      height: "100%",
      fill: "#8d8f91"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-4 text-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "card-title placeholder-glow mb-4" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-6 p-3" })
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "card-text placeholder col-12 mb-2" }),
    /*#__PURE__*/_createElementVNode("p", { class: "card-text placeholder col-10 mb-2" }),
    /*#__PURE__*/_createElementVNode("p", { class: "card-text placeholder col-11 mb-2" }),
    /*#__PURE__*/_createElementVNode("p", { class: "card-text placeholder col-7" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "card-body p-4" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-text" }

import { computed, PropType } from 'vue';
    import { CategoryViewModel } from '@/types/CategoryViewModel';
    import { useRootStore } from '@/store/root.store';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Categories',
  props: {
        excludeIds: {
            type: Array as PropType<number[]>,
            default: () => [] as number[],
        },
    },
  setup(__props) {

const props = __props

    const rootStore = useRootStore();

    

    const categories = computed<CategoryViewModel[]>(() => {
        if (!rootStore.categories.length) {
            return [];
        }

        if (props.excludeIds.length) {
            return rootStore.categories.filter(category => !props.excludeIds.includes(category.id));
        }

        return rootStore.categories;
    });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(rootStore).isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (index) => {
          return _createElementVNode("div", {
            class: "col mb-5",
            key: index
          }, _hoisted_3)
        }), 64))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(categories), (category) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col mb-5",
            key: category.id
          }, [
            _createVNode(_component_router_link, {
              to: { path: category.urlSlug },
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("div", {
                  class: "card h-100 shadow",
                  onClick: _withModifiers(navigate, ["stop"])
                }, [
                  _createElementVNode("picture", null, [
                    _createElementVNode("source", {
                      srcset: `/images/${category.file.name}.webp`,
                      type: "image/webp"
                    }, null, 8, _hoisted_5),
                    _createElementVNode("img", {
                      src: `/images/${category.file.name}.png`,
                      class: "card-img-top w-100",
                      alt: `Bild för kategori ${category.name}`
                    }, null, 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h4", _hoisted_9, _toDisplayString(category.name), 1),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(category.description), 1)
                    ])
                  ])
                ], 8, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
  ]))
}
}

})